
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'

function useScroll(distance: number = 100) {
  const isDisplay = ref(false)

  function onScroll(): void {
    isDisplay.value = window.pageYOffset > distance
  }

  onMounted(() => {
    window.addEventListener('scroll', onScroll)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
  })

  return {
    isDisplay
  }
}

function goTop(): void {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

export default defineComponent({
  setup() {
    const { isDisplay } = useScroll()

    return {
      isDisplay,
      goTop
    }
  }
})
